// eslint-disable-next-line func-names
(function($) {
  var App = (function() {
    // Base UI Actions
    function bindUiActions() {}

    return {
      init: function() {
        bindUiActions();
      }
    };
  })();

  App.init();
})(jQuery);
